import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { mockData } from '../mock';

const Footer = ({ onShowPrivacyPolicy, onShowImpressum, onShowCookieSettings }) => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const logoUrl = 'https://customer-assets.emergentagent.com/job_technikwegele/artifacts/vmv43psx_Gemini_Generated_Image_6fmu906fmu906fmu.png';

  return (
    <footer className="bg-gradient-to-br from-[#0a1632] to-[#1a2642] text-white">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-5 mb-8">
                <img 
                  src={logoUrl} 
                  alt="Elektrotechnik Wegele Logo" 
                  className="h-24 md:h-28 w-auto drop-shadow-2xl"
                />
                <div>
                  <h3 className="text-white font-bold text-xl md:text-2xl leading-tight drop-shadow-lg">
                    ELEKTROTECHNIK<br/>
                    <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                      WEGELE
                    </span>
                  </h3>
                </div>
              </div>
              <p className="text-white/80 mb-6 leading-relaxed max-w-md">
                Ihr zuverlässiger Partner für moderne Elektrotechnik in Reichling und Umgebung. 
                Staatlich geprüft, regional und immer auf dem neuesten Stand der Technik.
              </p>
              <div className="space-y-2">
                <div className="flex items-center space-x-3 text-white/80">
                  <Phone className="h-4 w-4" />
                  <span>{mockData.contact.phone}</span>
                </div>
                <div className="flex items-center space-x-3 text-white/80">
                  <Mail className="h-4 w-4" />
                  <span>{mockData.contact.email}</span>
                </div>
                <div className="flex items-center space-x-3 text-white/80">
                  <MapPin className="h-4 w-4" />
                  <span>{mockData.contact.address}</span>
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 className="font-bold text-lg mb-6">Navigation</h4>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => scrollToSection('#home')}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Startseite
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#services')}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Leistungen
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#projects')}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Projekte
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => scrollToSection('#contact')}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Kontakt
                  </button>
                </li>
                <li>
                  <button 
                    onClick={onShowImpressum}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Impressum
                  </button>
                </li>
                <li>
                  <button 
                    onClick={onShowPrivacyPolicy}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Datenschutz
                  </button>
                </li>
                <li>
                  <button 
                    onClick={onShowCookieSettings}
                    className="text-white/80 hover:text-white transition-colors duration-300"
                  >
                    Cookie Einstellungen
                  </button>
                </li>
              </ul>
            </div>

            {/* Instagram */}
            <div className="flex flex-col items-center text-center">
              <h4 className="font-bold text-lg mb-6">Folgen Sie uns</h4>
              <div className="flex flex-col items-center">
                <a 
                  href={`https://instagram.com/${mockData.contact.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col items-center"
                >
                  <div className="w-20 h-20 bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 rounded-2xl flex items-center justify-center hover:scale-110 transition-all duration-300 shadow-2xl hover:shadow-purple-500/25 mb-3">
                    <Instagram className="h-10 w-10 text-white" />
                  </div>
                  <p className="text-center text-white/80 group-hover:text-white transition-colors">
                    {mockData.contact.instagram}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-white/10 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-sm">
              © Elektrotechnik Wegele. Alle Rechte vorbehalten.
            </div>
            <div className="text-white/60 text-sm">
              Staatlich geprüfter Elektrotechniker
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;